<template>
    <footer class="c-o-site-footer no-print">
        <div
            class="c-o-site-footer__inner c-o-site-footer__inner--theme-primary c-o-site-footer__inner--thin"
        >
            <router-link
                to="/"
                class="c-o-site-footer__logo"
                aria-label="Till startsidan"
            >
                <lazy-image
                    classes="c-o-site-footer__logo-img c-o-site-footer__logo-img--desktop"
                    src="/assets/images/logo/Brabyggare-logo-RGB-neg.png"
                    alt="BraByggares logotyp"
                />
            </router-link>
        </div>
        <div
            v-if="!isLoading && (contactMenu || footerMenu)"
            class="c-o-site-footer__inner c-o-site-footer__inner--direction-column c-o-site-footer__inner--theme-secondary"
        >
            <div v-if="contactMenu" class="c-o-site-footer__nav">
                <div
                    v-for="(menu, index) in contactMenu"
                    :key="`contact-menu-${index}`"
                    class="c-o-site-footer__nav-group"
                >
                    <div v-if="menu.acf_fc_layout == `menu_block`">
                        <h3 class="c-o-site-footer__nav-heading">
                            {{ menu.title }}
                        </h3>
                        <ul class="c-o-site-footer__nav-list">
                            <li
                                v-for="(link, index) in menu.links"
                                :key="`contact-menu-link-${index}`"
                                class="c-o-site-footer__nav-item"
                            >
                                <icon v-if="link.icon" :icon="link.icon"></icon>
                                <router-link
                                    v-if="link.acf_fc_layout == `internal_link`"
                                    :to="
                                        `/info/$link.internal_link.post_name}/`
                                    "
                                    class="c-o-site-footer__nav-link"
                                >
                                    {{ link.internal_link.post_title }}
                                </router-link>
                                <div
                                    v-else-if="
                                        link.acf_fc_layout == `external_link` &&
                                            isMobile
                                    "
                                >
                                    <a
                                        :href="link.external_link.url"
                                        class="c-o-site-footer__nav-link"
                                    >
                                        {{ link.external_link.title }}
                                    </a>
                                </div>
                                <div
                                    v-else-if="
                                        link.acf_fc_layout == `external_link` &&
                                            !isMobile
                                    "
                                >
                                    <p
                                        v-if="link.icon === 'phone'"
                                        class="c-o-site-footer__nav-link"
                                    >
                                        {{ link.external_link.title }}
                                    </p>
                                    <a
                                        v-else
                                        :href="link.external_link.url"
                                        class="c-o-site-footer__nav-link"
                                    >
                                        {{ link.external_link.title }}
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-else-if="menu.acf_fc_layout == `text_block`">
                        <h3 class="c-o-site-footer__nav-heading">
                            {{ menu.title }}
                        </h3>
                        <div
                            class="c-o-site-footer__nav-text"
                            v-if="menu.text"
                            v-html="menu.text"
                        ></div>
                    </div>
                </div>
                <div class="c-o-site-footer__nav-group">
                    <div class="c-o-site-footer__social" v-if="!isLoading">
                        <ul class="c-o-site-footer__nav-list">
                            <li
                                v-for="(link, index) in socialMediaLinks"
                                :key="`sm-link-${index}`"
                                class="c-o-site-footer__nav-item"
                            >
                                <icon :icon="link.icon"></icon>
                                <a
                                    :href="link.url"
                                    target="_blank"
                                    :title="link.label"
                                >
                                    <div>
                                        <p class="c-o-site-footer__nav-link">
                                            {{ link.label }}
                                        </p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- footer meny-->
            <div v-if="footerMenu" class="c-o-site-footer__nav">
                <div
                    v-for="(menu, index) in footerMenu"
                    :key="`footer-menu-${index}`"
                    class="c-o-site-footer__nav-group"
                >
                    <div v-if="menu.acf_fc_layout == `menu_block`">
                        <h3 class="c-o-site-footer__nav-heading">
                            {{ menu.title }}
                        </h3>
                        <ul class="c-o-site-footer__nav-list">
                            <li
                                v-for="(link, index) in menu.links"
                                :key="`footer-menu-link-${index}`"
                                class="c-o-site-footer__nav-item"
                            >
                                <icon v-if="link.icon" :icon="link.icon"></icon>
                                <router-link
                                    v-if="link.acf_fc_layout == `internal_link`"
                                    :to="
                                        `/info/${link.internal_link.post_name}/`
                                    "
                                    class="c-o-site-footer__nav-link"
                                >
                                    {{ link.internal_link.post_title }}
                                </router-link>
                                <a
                                    v-else-if="
                                        link.acf_fc_layout == `external_link`
                                    "
                                    :href="link.external_link.url"
                                    class="c-o-site-footer__nav-link"
                                >
                                    {{ link.external_link.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div v-else-if="menu.acf_fc_layout == `text_block`">
                        <h3 class="c-o-site-footer__nav-heading">
                            {{ menu.title }}
                        </h3>
                        <div
                            class="c-o-site-footer__nav-text"
                            v-if="menu.text"
                            v-html="menu.text"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Icon from "../atoms/AtomIcon.vue";
import LazyImage from "../atoms/LazyImage.vue";

import { mapGetters } from "vuex";
import {
    GET_CONTACT_MENU,
    GET_FOOTER_MENU,
    GET_SOCIAL_MEDIA_LINKS,
    IS_LOADING,
    GET_ERROR
} from "../../../store/store-models/meta-model";

export default {
    components: {
        Icon,
        LazyImage
    },
    data() {
        return {
            partners: [
                {
                    url: "https://www.villaagarna.se/",
                    title: "Villaägarna",
                    images: {
                        original:
                            "/assets/images/partners/villaagarna-grey.png",
                        colored: "/assets/images/partners/villaagarna.png"
                    }
                },
                {
                    url: "https://www.brandskyddsforeningen.se/",
                    title: "Brandskyddsföreningen",
                    images: {
                        original: "/assets/images/partners/brandskydd-grey.png",
                        colored: "/assets/images/partners/brandskydd.png"
                    }
                },
                {
                    url: "https://www.golvbranschen.se/",
                    title: "Golvbranschen",
                    images: {
                        original:
                            "/assets/images/partners/golvbranschen-grey.png",
                        colored: "/assets/images/partners/golvbranschen.png"
                    }
                },
                {
                    url: "https://www.maleriforetagen.se/",
                    title: "Måleriföretagen",
                    images: {
                        original:
                            "/assets/images/partners/maleriforetagen-grey.png",
                        colored: "/assets/images/partners/maleriforetagen.png"
                    }
                },
                {
                    url: "https://www.bkr.se/",
                    title: "Byggkeramikrådet",
                    images: {
                        original:
                            "/assets/images/partners/byggkeramik-grey.png",
                        colored: "/assets/images/partners/byggkeramik.png"
                    }
                },
                {
                    url: "https://www.installatorsforetagen.se/",
                    title: "Installatörsföretagen",
                    images: {
                        original:
                            "/assets/images/partners/installatorsforetagen-grey.png",
                        colored:
                            "/assets/images/partners/installatorsforetagen.png"
                    }
                }
            ],
            activePartner: null,
            isMobile: this.$isMobile
        };
    },
    computed: {
        ...mapGetters({
            contactMenu: GET_CONTACT_MENU,
            footerMenu: GET_FOOTER_MENU,
            socialMediaLinks: GET_SOCIAL_MEDIA_LINKS,
            isLoading: IS_LOADING,
            error: GET_ERROR
        })
    },
    methods: {
        hoverPartner(i) {
            this.activePartner = `partner-${i}`;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismSiteFooter.vue